import React, { useState } from "react";
import { Header } from "./homepage/header";
import { TravelList } from "../components/travel_list";
import { Footer } from "../footer/footer";


export function Home(){
    const [isHomepageReady, setIsHomepageReady] = useState(false);

    return(
        <div>
            {isHomepageReady && <Header />}
            <TravelList onLoaded={() => setIsHomepageReady(true)} />
            {isHomepageReady && <Footer />}
        </div>
    );
}
